import { render, staticRenderFns } from "./GunBrokerDescriptionField.vue?vue&type=template&id=131e2364&scoped=true"
import script from "./GunBrokerDescriptionField.vue?vue&type=script&lang=js"
export * from "./GunBrokerDescriptionField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "131e2364",
  null
  
)

export default component.exports